// Layout.js
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import AnnouncementPopup from "./announcements/AnnouncementPopup";
import useAnnouncementPopup from "../hooks/useAnnouncementPopup";
import { isInternalAnnouncementUrl } from "../utils/announcementUtils";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // mobile drawer
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // desktop collapse
  const {
    currentAnnouncement,
    actionLoading: announcementActionLoading,
    handleDismiss,
    handleAcknowledge,
  } = useAnnouncementPopup(location.pathname);

  const isLoginOrRegister =
    location.pathname === "/login" || location.pathname === "/register";

  const backgroundStyle = isLoginOrRegister
    ? {}
    : {
        background:
          "radial-gradient(103.89% 81.75% at 95.41% 106.34%, #eaf8ef 6%, rgba(234, 248, 239, 0) 79.68%), radial-gradient(297.85% 151.83% at -21.39% 8.81%, #faf1f1 0%, #faf1f1 15.29%, #f3edf5 21.39%, #e5f0fa 40.79%)",
      };

  // ✅ desktop เท่านั้นที่ขยับ content: กาง = md:ml-64, พับ = md:ml-0
  const contentShiftClass = isSidebarCollapsed ? "md:ml-0" : "md:ml-64";

  // Layout.js (เฉพาะคลาสที่เปลี่ยน)
  return (
    <div
      className="flex w-full max-w-[100vw] overflow-x-hidden"
      style={backgroundStyle}
    >
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        desktopCollapsed={isSidebarCollapsed}
        setDesktopCollapsed={setIsSidebarCollapsed}
      />

      <div
        className={`flex-1 flex flex-col min-h-screen transition-all ml-0 ${contentShiftClass} w-full max-w-full`}
      >
        <Header
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        {/* มือถือปิด x-scroll / desktop เปิดได้ */}
        <main className="flex-1 w-full max-w-full min-h-screen overflow-y-auto overflow-x-hidden md:overflow-x-auto bg-white shadow rounded">
          {children}
        </main>
      </div>

      <AnnouncementPopup
        announcement={currentAnnouncement}
        loading={announcementActionLoading}
        onDismiss={handleDismiss}
        onAcknowledge={handleAcknowledge}
        onNavigate={(url) => {
          if (isInternalAnnouncementUrl(url)) {
            navigate(url);
            return;
          }

          window.open(url, "_blank", "noopener,noreferrer");
        }}
      />
    </div>
  );
};

export default Layout;
